import React from 'react';
import SimplePageHeader from '@/header/SimplePageHeader';
import ProfileTabs from '@/header/ProfileTabs';

function ProfileHeader({ active }) {
    return (
        <SimplePageHeader pageFixerClassName="tabs">
            <ProfileTabs active={active} />
        </SimplePageHeader>
    );
}

export default ProfileHeader;
